/* eslint-disable */
import { useEffect } from "react";
import Header from "components/Common/Header/Header";
import GroupPartnerBody from "components/GroupComponents/GroupDetails/GroupPartner/GroupPartnerBody/GroupPartnerBody";

const GroupPartner = () => {
  useEffect(() => {
    document.title = "Group Sponsor";
  }, []);

  return (
    <main id="app">
      {/* ---- header start ---- */}
      <Header moduleName="events" />
      {/* --- header end --- */}
      <GroupPartnerBody />
    </main>
  );
};

export default GroupPartner;
